module.exports = __webpack_public_path__ + "static/media/pest-control.bef5ed47.jpg";